import { OpenInNew } from '@mui/icons-material'
import { Box, IconButton, Stack, Typography } from '@mui/material'

interface Props {
  onClickOpenModal?: () => void
  children: string
}

const SectionHeader = ({ children, onClickOpenModal }: Props) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-evenly"
      display="flex"
      flex={1}
      p={0.5}
      pl={1}
      sx={theme => ({ backgroundColor: theme.palette.grey[200] })}
    >
      <Box flex={1}></Box>
      <Box flex={1} display="flex" alignItems="flex-start" justifyContent="center">
        <Typography>{children}</Typography>
      </Box>

      <Stack display="flex" justifyContent="flex-end" flex={1} direction="row">
        <Box pr={1}>
          {onClickOpenModal && (
            <IconButton onClick={onClickOpenModal} size="small" sx={{ padding: 0 }}>
              <OpenInNew />
            </IconButton>
          )}
        </Box>
      </Stack>
    </Stack>
  )
}

export default SectionHeader
